import { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuid } from 'uuid';
import { showAddEditPlace, hideAddEditPlace } from '../store/actions/placeDialog.actions';

export const usePlaceDialog = () => {
  const dispatch = useDispatch();
  const savedResult = useSelector((state) => state.placeDialog.savedResult);
  const pendingRequest = useRef(null);

  useEffect(() => {
    const request = pendingRequest.current;
    if (!request || savedResult?.requestId !== request.requestId || !savedResult.place) return;

    const callback = savedResult.isEditMode ? request.onPlaceUpdated : request.onPlaceCreated;
    callback?.(savedResult.place);
  }, [savedResult]);

  const openPlaceDialog = useCallback(
    (placeId = null, options = {}) => {
      const requestId = uuid();
      pendingRequest.current = { ...options, requestId };
      dispatch(
        showAddEditPlace({
          placeId,
          initialAddressId: options.initialAddressId,
          requestId,
          closeOnSave: options.closeOnSave,
          initialMenuKey: options.initialMenuKey,
        })
      );
    },
    [dispatch]
  );

  const closePlaceDialog = useCallback(
    (requestId = null) => dispatch(hideAddEditPlace(requestId)),
    [dispatch]
  );

  return { openPlaceDialog, closePlaceDialog };
};
